import React from 'react';

import FirmwareManagement from '../../components/Admin/FirmwareManagement'

import MainBlockHeader from '../MainBlockHeader'
import MainBlockContainer from '../MainBlockContainer';
import { useTranslation } from 'react-i18next';

export default function FirmwarePage() {
  const { t } = useTranslation();

  return (
    <>
      <MainBlockHeader header={t('admin.firmware.pageTitle')} >
      </MainBlockHeader>

      <MainBlockContainer>
        <FirmwareManagement />
      </MainBlockContainer>
    </>
  );
}
